import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import PropTypes from 'prop-types'

class Slider extends React.Component {
  render() {
    const { slides, activeFilter, isMD, isSM } = this.props

    const setSlideDisplayStyle = (slide, activeFilter) => {
      if (
        !activeFilter ||
        (slide.categories &&
          slide.categories.some(category => category.name === activeFilter))
      ) {
        return 'show-parent'
      } else {
        return 'hide-parent'
      }
    }

    return (
      <Splide
        options={{
          type: 'loop',
          perPage: isSM ? 1 : isMD ? 2 : 3,
          perMove: 1,
          pagination: false,
          autoplay: true,
        }}
      >
        {slides
          .filter(
            slide => setSlideDisplayStyle(slide, activeFilter) === 'show-parent'
          )
          .map((slide, i) => {
            return (
              <SplideSlide key={i}>
                <div
                  className={`${setSlideDisplayStyle(
                    slide,
                    activeFilter
                  )} slide-child`}
                >
                  <div className="slider-border">
                    <img
                      className="slider-image lazyload"
                      src={slide.image.url}
                      alt={slide.image.alt || slide.title}
                    />
                    {slide.newcomerDownloadLink &&
                      slide.newcomerDownloadLinkText && (
                        <a
                          className="downloads-button"
                          target="_blank"
                          rel="noreferrer"
                          href={slide.newcomerDownloadLink.link.url}
                        >
                          {slide.newcomerDownloadLinkText.linkText}
                        </a>
                      )}
                  </div>
                </div>
              </SplideSlide>
            )
          })}
      </Splide>
    )
  }
}

Slider.propTypes = {
  slides: PropTypes.array.isRequired,
  activeFilter: PropTypes.string,
  isMD: PropTypes.bool,
  isSM: PropTypes.bool,
}

export default Slider
